import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'
import classNames from 'classnames'

import { MODES } from '@aytm/app/stats/page/question-views/bpm/lib/modes'

import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'

import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'

import style from '@aytm/app/stats/page/question-views/bpm/components/styles/ModeSection.module.scss'

// One sub-mode, drawn: the strip over it, its chart and its table, each looked up rather than
// branched on. Both the question block and an info-view chart draw a sub-mode through here; they
// differ only in the switcher they hand down, and an info-view chart hands down none - which is
// also what drops the strip's first row, since there is then nothing to switch between.
//
// This component stays put across a switch on purpose. The placeholder below remembers whether the
// block has been reported on screen, so it has to survive the swap - only the chart inside it is
// allowed to change, or the incoming chart falls back behind a placeholder waiting for a report
// that has already been made.
const ModeSection = ({ mode, components, switcher = null, chartMode, answer, ...view }) => {
  const { Controls, Header, Chart, Table, height, split = false } = MODES[mode]

  return (
    <>
      {isComponentOn(components, 'controls') && (
        <div className={classNames(style.top, { [style.split]: split, [style.plain]: !switcher })}>
          {switcher && <div className={style.tabs}>{switcher}</div>}
          <div className={style.right}>{Header && <Header answer={answer} {...view} />}</div>
          <div className={style.filters}>
            <Controls answer={answer} {...view} />
          </div>
        </div>
      )}
      {isComponentOn(components, 'chart') && !isNoneChartMode(chartMode) && (
        <ChartPlaceholder height={height} required isLoading={'loading' === answer}>
          <Chart answer={answer} chartMode={chartMode} {...view} />
        </ChartPlaceholder>
      )}
      {isComponentOn(components, 'table') && <Table answer={answer} {...view} />}
    </>
  )
}

ModeSection.displayName = 'BpmModeSection'

ModeSection.propTypes = {
  mode: PropTypes.oneOf(['q', 't', 'm']).isRequired,
  components: PropTypes.object,
  switcher: PropTypes.node,
  chartMode: PropTypes.string,
  answer: answerPropType
}

export default ModeSection
